import * as Sentry from '@sentry/browser';
import App from 'components/App';
import { Intl, LocaleStateProvider } from 'components/organisms/Intl';
import Router from 'components/organisms/Router';
import { localStorage as localStorageConstant } from 'constants/index';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Global, css } from '@emotion/react';
import fcmToken from 'utils/fcmToken';
import refresh from 'utils/refresh';
import resetViewport from 'utils/resetViewport';
import setVh from 'utils/setVh';
import userAgent from 'utils/userAgent';
import { colors } from 'constants/colors';
Sentry.init({
    dsn: 'https://0eacf2eef72a45dc8dee4d6d747da7da@sentry.io/1417182',
    environment: process.env.NODE_ENV !== 'local' ? process.env.NODE_ENV : undefined,
});
if (window.location.search.indexOf('billing') >= 0) {
    localStorage.setItem(localStorageConstant.BILLING_FLAG, 'billing');
}
if (window.location.search.indexOf('reset-token') >= 0) {
    localStorage.removeItem(localStorageConstant.TEACHERS_AUTH_TOKEN_KEY);
    localStorage.removeItem(localStorageConstant.STUDENTS_AUTH_TOKEN_KEY);
}
const globalStyled = css `
  @font-face {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 400;
    src:
      local('Noto Sans CJK JP Regular'),
      url(//fonts.gstatic.com/ea/notosansjp/v5/NotoSansJP-Regular.woff2) format('woff2'),
      url(//fonts.gstatic.com/ea/notosansjp/v5/NotoSansJP-Regular.woff) format('woff'),
      url(//fonts.gstatic.com/ea/notosansjp/v5/NotoSansJP-Regular.otf) format('opentype');
  }
  html,
  body {
    font-family: 'Roboto', 'Noto Sans Japanese', 'Noto Sans JP', sans-serif;
    background-color: ${colors.f6f7fb};
    touch-action: manipulation;
    min-height: calc(var(--vh, 1vh) * 100);
  }
  .is-pc {
    background-color: ${colors.cce5ef};
  }
  * {
    overflow-wrap: break-word;
    line-height: 1;
    -webkit-tap-highlight-color: ${colors['00000000']};
    tap-highlight-color: ${colors['00000000']};
  }
  a,
  a:hover,
  a:visited,
  a:active {
    text-decoration: none;
    -webkit-tap-highlight-color: ${colors['00000000']};
    tap-highlight-color: ${colors['00000000']};
  }
  button {
    appearance: none;
    border: none;
    outline: none;
    padding: 0;
    background-color: transparant;
    user-select: none;
  }

  // windows OSのブラウザーのスクロールバーのみUIを変更される
  body.windows-scrollbar ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  body.windows-scrollbar ::-webkit-scrollbar-thumb {
    background-color: ${colors['05446680']};
    border-radius: 4px;
    border: 3px solid ${colors['3269f580']};
  }

  body.windows-scrollbar ::-webkit-scrollbar-track {
    background: ${colors.d9d9d9};
    border-radius: 2px;
  }
`;
// windows OSのブラウザーのスクロールバーのみUIを変更される
const applyCustomScrollbarOnWindows = () => {
    if (navigator.userAgent.includes('Win')) {
        document.body.classList.add('windows-scrollbar');
    }
};
applyCustomScrollbarOnWindows();
const container = document.querySelector('#app');
const root = createRoot(container);
root.render(React.createElement(LocaleStateProvider, null,
    React.createElement(Global, { styles: globalStyled }),
    React.createElement(Intl, null,
        React.createElement(Router, null,
            React.createElement(App, null)))));
setVh();
userAgent();
fcmToken();
refresh();
resetViewport();
